import React from 'react';

import SubscribeIcon from '../../icons/SubscribeIcon';

import IconBadge from './IconBadge';

const SubscribedBadge = () => <IconBadge icon={<SubscribeIcon />} />;

export default SubscribedBadge;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/canonical-card/badges/SubscribedBadge.js